import {HttpClient} from "../../service/httpClient/HttpClient";
import {convertPersianDateToUniversalDate} from "../../util/DateConvertor";
import {uploadFile} from "../../service/uploaderService/UploaderService";

export class UserService {
    constructor() {
        this.httpClient = new HttpClient()
    }

    getUsersList(page, size, fundID, fullNameFilter, groupNameFilter, nationalCodeFilter) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                "funds/" + fundID + "/members",
                {
                    size: size,
                    page: page,
                    "full-name": fullNameFilter,
                    "group-name": groupNameFilter,
                    "national-code": nationalCodeFilter
                }
            ).then(resolve).catch(reject)
        })
    }

    getUserInformation(fundID, userId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${fundID}/members/${userId}`,
            ).then(resolve).catch(reject)
        })
    }

    updateUserInformation(
        fundID, userId,
        avatarFile, avatarId,
        firstName, lastName,
        isMale, nationalCode, personalCode,
        fixedNumber, birthday, education, phoneNumber,
        job, groupSelectedID, address, enabled, userName) {
        return new Promise((resolve, reject) => {

            if (avatarFile) {
                this.uploadImageFile(avatarFile, () => {
                }, () => {
                }).then(response => {
                    this.doUpdateInfo(
                        response.id,
                        fundID,
                        userId,
                        firstName,
                        lastName,
                        isMale,
                        nationalCode,
                        personalCode,
                        fixedNumber,
                        birthday,
                        education,
                        phoneNumber,
                        job,
                        groupSelectedID,
                        address,
                        enabled
                    ).then(resolve).catch(reject)
                }).catch(reject)
            } else {
                this.doUpdateInfo(
                    avatarId,
                    fundID,
                    userId,
                    firstName,
                    lastName,
                    isMale,
                    nationalCode,
                    personalCode,
                    fixedNumber,
                    birthday,
                    education,
                    phoneNumber,
                    job,
                    groupSelectedID,
                    address,
                    enabled
                ).then(resolve).catch(reject)
            }
        })

    }

    getUserEnabled(userId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `/users/${userId}/enabled`,
            ).then(resolve).catch(reject)
        })
    }

    updateUserEnabled(userId, enabled) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `/users/${userId}/enabled`,
                {
                    enabled
                }
            ).then(resolve).catch(reject)
        })
    }

    addNewUser(
        fundID,
        imageFile,
        firstName,
        lastName,
        userName,
        password,
        gender,
        nationalCode,
        personalCode,
        phoneNumber,
        fixedNumber,
        birthday,
        education,
        job,
        groupSelectedID,
        address,
        enabled
    ) {

        return new Promise((resolve, reject) => {
            if (imageFile) {
                this.uploadImageFile(imageFile, () => {
                }, () => {
                })
                    .then(response => {
                        this.doAddNewUser(
                            fundID,
                            response.id,
                            firstName,
                            lastName,
                            userName,
                            password,
                            gender,
                            nationalCode,
                            personalCode,
                            phoneNumber,
                            fixedNumber,
                            birthday,
                            education,
                            job,
                            groupSelectedID,
                            address,
                            enabled,
                        ).then(resolve).catch(reject)
                    }).catch(reject)
            } else {
                this.doAddNewUser(
                    fundID,
                    gender ? "1" : "2",
                    firstName,
                    lastName,
                    userName,
                    password,
                    gender,
                    nationalCode,
                    personalCode,
                    phoneNumber,
                    fixedNumber,
                    birthday,
                    education,
                    job,
                    groupSelectedID,
                    address,
                    enabled,
                ).then(resolve).catch(reject)
            }
        })

    }


    doAddNewUser(fundID, imageId, firstName, lastName,
                 userName,
                 password, isMale,
                 nationalCode, personalCode,
                 phoneNumber, fixedNumber, birthday,
                 education, job, groupSelectedID,
                 address, enabled) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `/funds/${fundID}/groups/${groupSelectedID}/members`,
                {
                    "firstName": firstName,
                    "lastName": lastName,
                    "username": userName && userName.length > 0 ? userName : null,
                    "password": password && password.length > 0 ? password : null,
                    "enabled": enabled,
                    "gender": isMale === "MALE",
                    "phoneNumber": phoneNumber && phoneNumber.length > 0 ? phoneNumber : null,
                    "nationalCode": nationalCode,
                    "birthdate": birthday,
                    "degreeEducation": education && education.length > 0 ? education : null,
                    "jobTitle": job && job.length > 0 ? job : null,
                    "tellNumber": fixedNumber && fixedNumber.length > 0 ? fixedNumber : null,
                    "nBirthCertificate": personalCode && personalCode.length > 0 ? personalCode : null,
                    "postalAddress": address && address.length > 0 ? address : "",
                    "avatarId": imageId
                }
            ).then(resolve).catch(reject)
        })
    }


    uploadImageFile(imageFile, handleHideLoading, setUploadPercent) {
        return new Promise((resolve, reject) => {
            uploadFile(
                imageFile,
                setUploadPercent,
                () => {
                },
                handleHideLoading,
                `/avatars/compressing/MEDIUM`,
            ).then(resolve).catch(reject)
        })
    }

    updateUserPassword(fundID, userId, newPassword) {
        let formData = new URLSearchParams()
        formData.append("newPassword", newPassword)

        return new Promise((resolve, reject) => {
            new HttpClient(
                {},
                "application/x-www-form-urlencoded"
            ).put(
                `funds/${fundID}/members/${userId}/password`,
                formData
            ).then(resolve).catch(reject)
        })
    }

    updateUserName(fundID, userId, newUsername) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `funds/${fundID}/members/${userId}/username`,
                {
                    newUsername
                }
            ).then(resolve).catch(reject)
        })
    }

    doUpdateInfo(
        avatarId, fundID,
        userId, firstName,
        lastName, isMale,
        nationalCode, personalCode, fixedNumber,
        birthday, education,
        phoneNumber, job,
        groupSelectedID, address,
        enabled) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `funds/${fundID}/members/${userId}/groups/${groupSelectedID}`,
                {
                    "firstName": firstName,
                    "lastName": lastName,
                    "enabled": enabled,
                    "gender": isMale,
                    "phoneNumber": phoneNumber && phoneNumber.length > 0 ? phoneNumber : null,
                    "nationalCode": nationalCode,
                    "birthdate": convertPersianDateToUniversalDate(birthday),
                    "degreeEducation": education && education.length > 0 ? education : null,
                    "jobTitle": job && job.length > 0 ? job : null,
                    "tellNumber": fixedNumber && fixedNumber.length > 0 ? fixedNumber : null,
                    "nBirthCertificate": personalCode && personalCode.length > 0 ? personalCode : null,
                    "postalAddress": address && address.length > 0 ? address : null,
                    "avatarId": avatarId
                }
            ).then(resolve).catch(reject)
        })
    }
}